import type { MenuItem } from '@dealerportal/common';
import type { DOMNode } from 'html-react-parser';
import Link from 'next/link';
import { visible } from '../../../utilities/src/lib/camilyo';
import type { EnhancedDOMNode } from './Include';

type Props = {
  itemsinrow: number;
  id: string;
  className: string;
  showatstart: string;
  columnscount: number;
  showpromotedproduct: number;
  megamenusubmenulayout: number;
  showproductname: number;
  showproductshortdescription: boolean;
  useablock: boolean;
  maxwidth: string;
  sitemapstartlevel: string;
  sitemapentrypoint: string;
  sitemapdepth: string;
  menuItems: MenuItem[];
  elementsToRender: DOMNode[];
};

export function TabbedMultiMenu(props: Props) {
  let filteredItems: MenuItem[];
  if (props.elementsToRender.length === 0) {
    filteredItems = props.menuItems;
  } else {
    filteredItems = (props.elementsToRender as EnhancedDOMNode[])
      .filter((x) => x.tagName === 'menuitembase')
      .map((item) => ({
        text: item.attribs.text,
        href: item.attribs.href,
        visible: item.attribs.visible,
        items: [],
      }));
  }

  return (
    <nav role="navigation" aria-label="Main Menu">
      <ul id={props.id} className={`mlhmenu ${props.className}`} role="menu">
        {filteredItems
          .filter((item) => !item.visible || visible(item.visible))
          .map((item: MenuItem, index: number) => (
            <li
              className={`li_${props.className}${index}`}
              key={index}
              role="none" // Prevent assigning a conflicting role
            >
              <Link
                prefetch={false}
                role="menuitem"
                href={item.href ?? ''}
                className={`${props.className}_item`}
                style={{ float: 'none' }}
              >
                {item.text}
              </Link>
              {(item.children?.length ?? 0) > 0 && (
                <ul
                  id={`ul__${props.className}${index}`}
                  className={`${props.className}_submenu`}
                  role="menu"
                  style={{ width: '320px' }}
                >
                  {(item.children ?? []).map(
                    (child: MenuItem, childIndex: number) => (
                      <li
                        id={`li_${props.className}${index}${childIndex}`}
                        key={childIndex}
                        role="none"
                      >
                        <Link
                          role="menuitem"
                          href={child.href ?? ''}
                          className={`${props.className}_subitem`}
                          style={{ float: 'none', whiteSpace: 'nowrap' }}
                          prefetch={false}
                        >
                          {child.text}
                        </Link>
                        {(child.children?.length ?? 0) > 0 && (
                          <ul
                            id={`ul__${props.className}${index}${childIndex}`}
                            className={`${props.className}_submenu`}
                            role="menu"
                            style={{ left: '325px', top: '0px' }}
                          >
                            {child.children?.map(
                              (subChild: MenuItem, subChildIndex: number) => (
                                <li
                                  id={`li_${props.className}${index}${childIndex}${subChildIndex}`}
                                  key={subChildIndex}
                                  role="none"
                                >
                                  <Link
                                    role="menuitem"
                                    href={subChild.href ?? ''}
                                    className={`${props.className}_subitem ${props.className}_subitemlevel3`}
                                    style={{
                                      float: 'none',
                                      whiteSpace: 'nowrap',
                                    }}
                                    prefetch={false}
                                  >
                                    {subChild.text}
                                  </Link>
                                </li>
                              )
                            )}
                          </ul>
                        )}
                      </li>
                    )
                  )}
                </ul>
              )}
            </li>
          ))}
      </ul>
    </nav>
  );
}

export default TabbedMultiMenu;
